<div class="hubspot-modal">
  <div class="hubspot-popup">
    <span class="close-btn" (click)="closeHubspot()">×</span>
    <div class="meetings-iframe-container"
         [attr.data-src]="environment.BOOK_DEMO_EMBED_FRAME"></div>
  </div>
</div>